import React from 'react'

export const ContentStyles: { [key: string]: React.CSSProperties } = {
    container: { width: '100%', boxSizing: 'border-box' },
}
